// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".golos-naroda-module__container--1p0GB{background:#102c60;padding:20px 0}.golos-naroda-module__title--3pR_B{margin-bottom:2px}.golos-naroda-module__description--V0xS6,.golos-naroda-module__title--3pR_B{color:#fff;text-align:center}.golos-naroda-module__description--V0xS6{opacity:.5;margin-bottom:20px;padding:0 20px}.golos-naroda-module__staticSlider--2t86V{display:flex;gap:20px;justify-content:space-between}.golos-naroda-module__static--XNDp_{padding:20px 0;margin:60px 0}@media screen and (min-width:1152px){.golos-naroda-module__static--XNDp_{padding:20px 30px 30px;margin:75px 0}}.golos-naroda-module__small--2WEeT{margin-top:25px;margin-bottom:45px}@media screen and (min-width:1152px){.golos-naroda-module__small--2WEeT{margin-bottom:0}}", ""]);
// Exports
exports.locals = {
	"container": "golos-naroda-module__container--1p0GB",
	"title": "golos-naroda-module__title--3pR_B",
	"description": "golos-naroda-module__description--V0xS6",
	"staticSlider": "golos-naroda-module__staticSlider--2t86V",
	"static": "golos-naroda-module__static--XNDp_",
	"small": "golos-naroda-module__small--2WEeT"
};
module.exports = exports;
